import { Reveal } from "./Reveal";
import { ArrowRight } from "lucide-react";

export const CtaBanner = () => (
  <section className="py-28 sm:py-40 bg-white text-black" data-testid="cta-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <Reveal>
        <h2 className="font-display font-extrabold uppercase tracking-tighter leading-[0.95] text-4xl sm:text-6xl lg:text-7xl max-w-5xl mx-auto">
          Your truck has a destination. Your business has a purpose.
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="text-neutral-600 text-base sm:text-lg max-w-xl mx-auto mt-8 mb-10">
          Let Purpose Haul handle the dispatch side so you can focus on operating your business.
        </p>
      </Reveal>
      <Reveal delay={0.25}>
        <a
          href="#contact"
          data-testid="cta-start-onboarding-button"
          className="group inline-flex items-center gap-3 bg-black text-white font-mono text-xs uppercase tracking-[0.2em] px-8 py-4 hover:bg-neutral-800 transition-colors duration-300"
        >
          Start Your Onboarding
          <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
        </a>
      </Reveal>
    </div>
  </section>
);
